import type React from 'react';
import { lazy, Suspense } from 'react';
import { PageLoading } from '@/app/components/page-loading.tsx';

const LazyRepresentativePublicProfile = lazy(() => import('./RepresentativePublicProfile'));

const RepresentativePublicProfile = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => (
  <Suspense fallback={<PageLoading />}>
    <LazyRepresentativePublicProfile {...props} />
  </Suspense>
);

export const repPublicProfileRoute = {
  path: '/rep-public-profile/:key',
  element: <RepresentativePublicProfile />,
};
export default RepresentativePublicProfile;
